import { createRouter, createWebHistory } from 'vue-router'
import { useGlobalStore } from '@/stores/global'
import { useLoadingStore } from '@/stores/loading'
import { useStatisticsStore } from '@/stores/statistics'
import { useCustomRouter } from './useCustomRouter'
import { Config as PagePortalConfig } from '@/pages/config'
import { Config as PageFrConfig } from '@page/locales/fr/config'
import { Config as PageEnConfig } from '@page/locales/en/config'
import { Config as PageHomeConfig } from '@page/home/config'
import { Config as PageTermsConfig } from '@page/terms/config'
import { Config as PagePrivacyConfig } from '@page/privacy/config'
import { Config as PageCookiePolicyConfig } from '@page/cookiePolicy/config'
import { Config as PageCancelAppointmentConfig } from '@page/cancelAppointment/config'
import { Config as PageFAQConfig } from '@page/faq/config'
import { Config as PageContactUsConfig } from '@page/contactUs/config'
import { Config as PageStatsConfig } from '@page/stats/config'
import { Config as PageSurveyConfig } from '@page/survey/config'
import { Config as PageServiceConfig } from '@page/service/config'
import { Config as PageServicesConfig } from '@page/services/config'
import { Config as PageNewsConfig } from '@page/news/config'
import { Config as PageIFrameConfig } from '@page/iframe/config'
import { Config as PageNotFoundConfig } from '@page/notFound/config'
// AUTO-LOCAL-IMPORT-CONFIG [ /!\ DO NOT REMOVE THIS LINE]
import { Config as PageRemoteProfileConfig } from '@pageRemote/Profile/config'
// AUTO-REMOTE-IMPORT-CONFIG [ /!\ DO NOT REMOVE THIS LINE]

const routerOptions = {
  routes: [
    {
      path: '/:pathMatch(.*)*',
      redirect: 'not-found'
    },
    {
      ...PagePortalConfig,
      children: [
        PageNotFoundConfig,
        PageHomeConfig,
        PageEnConfig,
        PageFrConfig,
        PageTermsConfig,
        PagePrivacyConfig,
        PageCookiePolicyConfig,
        PageCancelAppointmentConfig,
        PageFAQConfig,
        PageContactUsConfig,
        PageStatsConfig,
        PageSurveyConfig,
        PageServicesConfig,
        PageServiceConfig,
        PageNewsConfig,
        PageIFrameConfig
        // AUTO-LOCAL-ROUTE-CONFIG [ /!\ DO NOT REMOVE THIS LINE]
      ]
    },
    PageRemoteProfileConfig
    // AUTO-REMOTE-ROUTE-CONFIG [ /!\ DO NOT REMOVE THIS LINE]
  ],
  scrollBehavior(to) {
    if (to.name === 'services') return { top: 0 }
  }
}

const initializeRouter = () => {
  routerOptions.history = createWebHistory(import.meta.env.BASE_URL)
  const router = createRouter(routerOptions)
  router.beforeEach(async (to, from, next) => {
    const globalStore = useGlobalStore()
    globalStore.routerHistory = { previous: from, current: to }
    useStatisticsStore()
      .fetchStatistics()
      .then(() => {
        useStatisticsStore().display = true
      })
      .catch((e) => console.error(e))

    next()
  })

  router.afterEach(() => {
    useCustomRouter().setAlreadyEntered()

    const loadingStore = useLoadingStore()

    if (loadingStore.isLoading) {
      loadingStore.toggleLoading({ set: false })
    }
  })

  return router
}

export { initializeRouter }
